<template>
	<div :style="customGap" 
	:class="['hoverBox','list-goods-item',{'up-to-down-layout':upDownLayout},{'has-bottom-border':bottomBorder},{'list-goods-item-last':lastFlag},{'goodsItemRow':isRow}]"
		@click.stop="toDetail()">
		<goods-image :goods="goods" :imageSize="imageSize" :showOutOfStock="showOutOfStock"></goods-image>
		<div :style="returnRowStyle" class="goods_detail">
            <div class="goods_name multi-hidden">
				<goodsLabel :goods="goods"></goodsLabel>
                <div class="goodsName textOverflow">
					{{ goods.goods_name }}
					<span v-if="goods_size">({{ goods_size }})</span>
				</div>
            </div>
			<goodsGroupLabel :goods="goods"></goodsGroupLabel>
			<slot name="price">
				<goodsPrice :info="goods"></goodsPrice>
			</slot>
			<ctrlShowText :info="goods" :showLimit="showLimit" :type="infoConfig.type" :wesArr="infoConfig.wesArr" :traArr="infoConfig.traArr"></ctrlShowText>
			<div style="flex: 1;"></div>
            <div>
                <slot name="addCart"></slot>
                <add-cart v-if="!$slots.addCart" :goods="goods" :showLimit="showLimit"></add-cart>
            </div>
		</div>
	</div>
</template>
<script>

import goodsPrice from '@/components/goods-price/goods-price.vue';
import { buyBtnAuth } from "@/utils/permission";
import ctrlShowText from "../ctrl-show-text/ctrl-show-text.vue";
import goodsImage from "../goods-image/goods-image.vue";
import goodsCodeLabel from "../goods-label/goods-code-label.vue";
import goodsGroupLabel from "../goods-label/goods-group-label.vue";
import goodsLabel from "../goods-label/goods-label.vue";
import AddCart from './add-cart.vue';
import Price from "./price.vue";
export default {
	name: "goods-list-item",
    components: { AddCart, Price ,ctrlShowText ,goodsPrice, goodsLabel,goodsCodeLabel,goodsGroupLabel,goodsImage},

	props: {
		goods: {
			type: Object,
			required: true,
			default: ''
		},
		lastFlag: {
			type: Boolean,
			default: false
		},
		imageSize: {
			type: [Number, String],
			default: 200
		},
		upDownLayout: {
			type: Boolean,
			default: false
		},
		bottomBorder: {
			type: Boolean,
			default: true
		},
		gap: {
			type: [Number, String],
			default: 10
		},
		addCart: {
			type: Boolean,
			default: true
		},
		showLimit:{
			type: Boolean,
			default: false
		},
		isRow:{
			type: Boolean,
			default: false
		},
		infoConfig:{
			type: Object,
			default: () => {
				return {
					type:'default',
					wesArr:[],
					traArr:[]
				}
			}
		},
		showOutOfStock: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {}
	},
	methods: {
		toDetail() {
            if(this.$listeners.click) {
                this.$emit('click');
                return;
            }
            const hasPermissionInfo = buyBtnAuth(this.goods);
			if (!hasPermissionInfo.disabled) {
				this.$router.pushToTab("/sku-" + this.goods.sku_id)
			} else {
              this.$message.error(hasPermissionInfo.text)
			}
		},
		goodsImageError() {
			this.goods.sku_image = this.$util.getDefaultImage().default_goods_img;
		},
		
	},
	computed: {
		returnActiveImage(){
			return this.goods.border_image || ''
		},
		returnRowStyle(){
			if(this.isRow){
				return `width: calc(100% - ${this.imageSize}px);`
			}
			return ''
		},
		customGap(){
			return `gap:${this.gap}px`
		},
		imgSize() {
			return `width: ${this.imageSize}px;height: ${this.imageSize}px;max-width: ${this.imageSize}px;max-height: ${this.imageSize}px;`;
		},
		storeToken() {
			return this.$store.state.member.token;
		},
		goods_size(){
			let size = null;
			let {attr} = this.goods;
			if(attr&&attr.goods_size&&attr.goods_size!==''){
				size = attr.goods_size;
			}
			return size;
		}
	}
}
</script>

<style>
.list-goods-item:last-of-type {
	border: none !important;
	margin: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
}
</style>

<style scoped lang="scss">
.textOverflow{
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.medicine_code{
	display: flex;
	align-items: center;
	gap: 3px;
	>div{
		display: flex;
		align-items: center;
		justify-content: center;
		>span{
			font-weight: 400;
			font-size: 11px;
			line-height: 16px;
		}
	}
	.code_cc{
		width: 39px;
		height: 16px;
		border-radius: 6px;
		border: 1px solid #6DD4C4;
		>span{
			color: #6DD4C4;
		}
	}
	.code_cb{
		width: 31px;
		height: 16px;
		border-radius: 6px;
		border: 1px solid #FFAA00;
		>span{
			color: #FFAA00;
		}
	}
	.code_tc{
		width: 41px;
		height: 16px;
		border-radius: 6px;
		border: 1px solid #32BC6F;
		>span{
			color: #32BC6F;
		}
	}
}
.coupon_price {
	display: inline-block;
	text-indent: 5px;
	line-height: normal;

	.ticket_font {
		color: #909399;
		margin-right: 5px;
	}

	.small_text {
		font-size: 16px;
	}

	.smaller_text {
		font-size: 14px
	}
}

.list-goods-item {
	flex-grow: 1;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	padding-bottom: 10px;
	margin-bottom: 10px;
    cursor: pointer;
}

.list-goods-item.has-bottom-border {
	border-bottom: 1px solid #ccc;
}

.list-goods-item.up-to-down-layout {
	gap: 10px;
	flex-direction: column;
	justify-content: space-between;
	padding-bottom: 0;
	margin-bottom: 0;


}

.goodsItemRow{
	flex-direction: row !important;
	align-items: flex-start;
	.goods_detail{
		flex-shrink: 0 !important;
		height: 100%;
	}
}

.list-goods-item-last {
	border: none !important;
	margin: 0;
}
.goods-image-box{
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
}
.goods-image {
	width: 100%;
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
	position: relative;
	z-index: 1;
}
.goods-active-image{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
	z-index: 2;
}
/* 多行超出隐藏 */
.multi-hidden {
	word-break: break-all;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.goods_detail {
    display: flex;
    flex-direction: column;
	position: relative;
	width: 100%;
	flex-grow: 1;
    justify-content: space-between;
    gap: 6px;
}

.goods_name {
	font-size: calc(var(--global-size) + 2px);
    font-weight: 400;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 6px;
	>.goodsName{
		font-weight: bold;
		>span{
			font-size: calc(var(--global-size) - 2px);
			color: #32BC6F;
		}
	}
}

.label-elements {
	display: flex;
	flex-wrap: wrap;
	gap: 6px
}

.goods_price {
	position: relative;
	display: flex;
	flex-direction: column;

    color: red;
    font-size: 16px;
    line-height: 24px;
	.goods-price-box image {
		margin-left: 4px;
		width: 62px;
		height: 24px;
	}

	.price-icon {
		margin-right: 2px;

	}

	.sale-price {

		margin-bottom: 10px;
	}

	.line-price {

		text-decoration: line-through;
	}

	.careBox {
		padding: 50px;
		position: absolute;
		bottom: -20px;
		right: -50px;
		height: 52px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.goods-info {

    font-size: 11px;
    color: #787878;


	.goods_attr_info {
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.add-goods-btn {
	position: absolute;
	bottom: 0;
	right: 0;
}

.goods_lable_row{
	display: flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
}
</style>
